import React, { Component } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { Row, Col, Button, Form, Input, DatePicker, Radio, message, Upload, Icon, Modal } from 'antd';
import 'antd/dist/antd.css';
import '../App.css'
import userProfileImageHolder from '../user_profile.jpg';
import moment from 'moment';

const API_HOST_URL = process.env.REACT_APP_API_URL


function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

class PersonalDetailsForm extends Component {

    state = {
        isDriver: true,
        gender: 'Male',
        loggedInUser: {},
        fileList: [],
        uploading: false,
        previewVisible: false,
        previewImage: this.props.loggedInUser.profile.profilePhoto != null ? this.props.loggedInUser.profile.profilePhoto : userProfileImageHolder,
    }

    handleImagePreviewCancel = () => this.setState({ previewVisible: false });

    handleImagePreview = async file => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }

        this.setState({
            previewImage: file.url || file.preview,
            previewVisible: false,
        });
    };

    componentWillMount() {
        console.log("props: ", this.props.loggedInUser)
        this.setState({
            loggedInUser: this.props.loggedInUser
        })
    }

    handleSubmit = (e) => {
        console.log("Filelist: ", this.state.fileList)
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            console.log("personal details values: ", values)
            if (!err) {
                if (this.props.isAuthenticated) {

                    let formData = new FormData();

                    formData.append('first_name', values.firstName);
                    formData.append('last_name', values.lastName);

                    if (this.state.fileList.length != 0) {
                        formData.append('profile.profilePhoto', this.state.fileList[0].originFileObj)
                    }

                    formData.append('profile.phoneNumber', values.phoneNumber)
                    // formData.append('profile.dateOfBirth', moment(values.dateOfBirth))
                    formData.append('profile.description', values.description)
                    formData.append('profile.gender', this.state.gender)
                    formData.append('profile.isDriver', this.state.isDriver)

                    return axios.put(`${API_HOST_URL}/rest-auth/user/`, formData,
                        {
                            headers: {
                                Authorization: 'Token ' + this.props.token,
                                'Content-Type': 'multipart/form-data'
                            }
                        })
                        .then(res => {
                            console.log(res)
                            message.success("Personal details updated successfully.");
                        })
                        .catch(error => {
                            message.error("Error occured. Update failed!");
                            console.log(error);
                        });
                } else {
                    console.log("Please login. U are not authenticated!")
                }
            }
        });
    }

    onChangeGender = e => {
        console.log("gender: ", e.target.value)
        this.setState({
            gender: e.target.value
        })
    }

    onChangeIsDriver = e => {
        console.log("IsDriver: ", e.target.value)
        this.setState({
            isDriver: e.target.value
        })
    }

    handleUpload = () => {
        const { fileList } = this.state;
        const formData = new FormData();
        fileList.forEach(file => {
            formData.append('files[]', file);
        });

        this.setState({
            uploading: true,
        });

    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const { TextArea } = Input;
        const { loggedInUser } = this.state;

        const props = {

            onRemove: file => {
                this.setState(
                    state => {
                        const index = state.fileList.indexOf(file);
                        const newFileList = state.fileList.slice();
                        newFileList.splice(index, 1);
                        return {
                            fileList: newFileList,
                        };
                    }
                );
            },

            beforeUpload: () => {
                return false;
            },

            onChange: info => {
                let fileList = [...info.fileList];

                // 1. Limit the number of uploaded files
                // Only to show two recent uploaded files, and old ones will be replaced by the new
                fileList = fileList.slice(-1);

                // 2. Read from response and show file link
                fileList = fileList.map(file => {
                    if (file.response) {
                        // Component will show file.url as link
                        file.url = file.response.url;
                    }
                    return file;
                });

                this.handleImagePreview(fileList[0])

                this.setState({ fileList: fileList });
            },

            fileList: this.state.fileList,
            showUploadList: false
        };

        const { previewVisible, previewImage } = this.state;

        return (
            <div>
                <h1>Personal Details</h1>
                <Form onSubmit={this.handleSubmit}>
                    <Row gutter={16}>
                        <Col md={{ span: 16 }}>
                            <Form.Item label="Phone Number">
                                {getFieldDecorator('phoneNumber', {
                                    initialValue: loggedInUser.profile.phoneNumber,
                                    rules: [{ required: true, message: 'Please enter Phone number' }],
                                })(
                                    <Input size="large" name="phoneNumber" placeholder="Phone Number" />
                                )}

                            </Form.Item>

                            <Form.Item label="First Name">
                                {getFieldDecorator('firstName', {
                                    initialValue: loggedInUser.first_name,
                                    rules: [{ required: true, message: 'Please enter First Name' }],
                                })(
                                    <Input size="large" name="firstName" placeholder="First Name" />
                                )}

                            </Form.Item>

                            <Form.Item label="Last Name">
                                {getFieldDecorator('lastName', {
                                    initialValue: loggedInUser.last_name,
                                    rules: [{ required: true, message: 'Please enter Last Name' }],
                                })(
                                    <Input size="large" name="lastName" placeholder="Last Name" />
                                )}

                            </Form.Item>

                            <Form.Item
                                label="Date Of Birth"
                                style={{ display: 'inline-block' }}
                            >
                                {getFieldDecorator('dateOfBirth',
                                    {
                                        initialValue: moment(loggedInUser.profile.dateOfBirth),
                                        rules: [{ type: 'object', required: true, message: 'Please select Date of Birth!' }],
                                    })(
                                        <DatePicker size="large" format="YYYY-MM-DD" />
                                    )}
                            </Form.Item>
                            <Form.Item
                                label="Description"
                            >
                                {getFieldDecorator('description', {
                                    initialValue: loggedInUser.profile.description,
                                    rules: [{ required: false }],
                                })(
                                    <TextArea rows={4} placeholder="Description" />
                                )}
                            </Form.Item>

                            <Form.Item label="Gender">
                                <Radio.Group size="large" defaultValue={loggedInUser.profile.gender} onChange={this.onChangeGender}>
                                    <Radio.Button value="Male">Male</Radio.Button>
                                    <Radio.Button value="Female">Female</Radio.Button>
                                </Radio.Group>
                            </Form.Item>
                            <Form.Item label="User Type">
                                <Radio.Group size="large" defaultValue={loggedInUser.profile.isDriver} onChange={this.onChangeIsDriver}>
                                    <Radio.Button value={true}>I'm a driver</Radio.Button>
                                    <Radio.Button value={false}>I'm a passenger</Radio.Button>
                                </Radio.Group>
                            </Form.Item>

                            <Form.Item>
                                <Button type="primary" htmlType="submit" style={{ height: '3em', marginRight: '10px', width: '100%', borderWidth: '0px' }}>
                                    Update
                                </Button>
                            </Form.Item>
                        </Col>
                        <Col md={{ span: 8 }}>
                            <div className="clearfix">
                                <img src={previewImage} style={{ height: '60%', width: '60%' }} alt="logo" onClick={() => { this.setState({ previewVisible: true }) }} />
                                <Upload {...props}>
                                    <Button>
                                        <Icon type="upload" /> Select Photo
                                    </Button>
                                </Upload>
                                <Modal visible={previewVisible} footer={null} onCancel={this.handleImagePreviewCancel}>
                                    <img alt="example" style={{ width: '100%' }} src={previewImage} />
                                </Modal>
                            </div>
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        isAuthenticated: state.token !== null,
        token: state.token,
        loggedInUser: state.currentUser
    }
}

const PersonalDetails = Form.create({ name: 'personal-details-form' })(PersonalDetailsForm);
export default connect(mapStateToProps, null)(PersonalDetails);

